import CreateButton from '@atlassian/jira-create-filter-button/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../../state/types.tsx';

const mapStateToProps = (_state: State) => ({});

export default connect(mapStateToProps, {})(CreateButton);
